"use client";

import { defaultReminderService } from "../../utils/reminderServiceAdapter";
import { __LIVE_LANDING_PAGE__ } from "../../constants/livelanding-page.constants";
import HeadlessPlaylistSection, {
  type HeadlessPlaylistSectionProps,
} from "./HeadlessPlaylistSection";
import type { ReminderService } from "../UpcomingLive/UpcomingLive";

export default function HeadlessPlaylistSectionWithServices(
  props: Readonly<HeadlessPlaylistSectionProps>
) {
  const reminderService: ReminderService = defaultReminderService;
  const influencerId = __LIVE_LANDING_PAGE__;

  return (
    <HeadlessPlaylistSection
      {...props}
      reminderService={reminderService}
      influencerId={influencerId}
    />
  );
}
